import request from '@/utils/request';

// AbCurrency查询列表
export const GetAbCurrency = parameter => request.get('/ab/select-by-currency-page', { params: parameter });